export class StringComparer {
  public static descending(value1: string, value2: string): number {
    return value2.localeCompare(value1);
  }

  public static ascending(value1: string, value2: string): number {
    return value1.localeCompare(value2);
  }
}
